import React, { useEffect, useMemo, useState } from 'react'
import {Link, useParams} from 'react-router-dom'
import {Input, Table, DropdownMenu, DropdownItem, UncontrolledDropdown, DropdownToggle} from 'reactstrap'
import { ApiSolicitudVacacionesService } from 'services/ApiSolicitudVacacionesService'
import { UncontrolledTooltip, Alert } from 'reactstrap'
import { useAuth } from 'context/AuthProvider'
import { apiMotivoAusenciasService } from 'services/apiMotivoAusenciasService'
const ListaAprobarVacaciones = (props) => {
  const [errorTramitar, setErrorTramitar] = useState("")
  const { empresa } = useAuth()
  const [motivos, setMotivos] = useState([])

  useEffect(() => {
    const fetchMotivos = async () => {
      try {
        const response = await apiMotivoAusenciasService.getAllByID(empresa.id)
        const data = await response.json()
        setMotivos(data)
      } catch (e) {
        setMotivos([])
      }
    }
    fetchMotivos()
  }, [empresa.id])

  const motivosById = useMemo(
    () => new Map(motivos.map((motivo) => [String(motivo.id), motivo])),
    [motivos]
  )

  const getTipoComputoLabel = (ausencia) => {
    const motivo = motivosById.get(String(ausencia.descripcion_id))
    if (!motivo?.tipoComputoDias) return "-"
    return motivo.tipoComputoDias === "NATURALES" ? "Naturales" : "Habiles"
  }

  async function handleTramitar(id, estado) {
    setErrorTramitar("")

    try {
      const response = await ApiSolicitudVacacionesService.postTramitar(id,estado)
      if (response.ok) {
        props.setUpdate(!props.update)
        return
      }

      let backendMessage = ""
      try {
        const data = await response.json()
        backendMessage = data?.message || data?.error || ""
      } catch (e) {
        backendMessage = ""
      }

      if (response.status === 409) {
        setErrorTramitar(
          "No se ha podido aprobar la solicitud porque ya existe una ausencia o vacaciones registrada para alguno de los dias seleccionados."
        )
        return
      }

      setErrorTramitar(backendMessage || "No se ha podido tramitar la solicitud.")
    } catch (e) {
      setErrorTramitar("Error de comunicacion al tramitar la solicitud.")
    }
  }

  return (
    <>
      {errorTramitar && (
        <Alert color="danger" className="mb-3">
          {errorTramitar}
        </Alert>
      )}
      <div className="table-responsive" style={{ width: '100%' }}>
      <Table className="align-items-center table-flush w-100" style={{ tableLayout: 'fixed', width: '100%' }}>
        <colgroup>
          <col style={{ width: '18%' }} />
          <col style={{ width: '20%' }} />
          <col style={{ width: '30%' }} />
          <col style={{ width: '14%' }} />
          <col style={{ width: '14%' }} />
          <col style={{ width: '16%' }} />
        </colgroup>
        <thead>
        <tr>
          <th style={{ whiteSpace: 'normal' }}>Tipo:</th>
          <th style={{ whiteSpace: 'normal' }}>Periodo solicitado:</th>
          <th style={{ whiteSpace: 'normal' }}>descripcion:</th>
          <th style={{ whiteSpace: 'normal' }}>Computo:</th>
          <th style={{ whiteSpace: 'normal' }}>Fecha solicitud:</th>
          <th style={{ whiteSpace: 'normal' }}>Tramitar</th>
        </tr>
        </thead>
        <tbody>
        {props.datos.map((dato, index) => (

            <tr key={dato.solicitud.id}>

              <td style={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}>{dato.ausencia.tipo}</td>

              <td style={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}>{dato.ausencia.fechaDesde} - {dato.ausencia.fechaHasta}</td>
              <td style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
                <span>{dato.ausencia.descripcion}</span>
                {dato.ausencia.comentario && (
                  <>
                    <span
                      id={`comentario-${index}` }
                      style={{
                        marginLeft: '8px',
                        cursor: 'help',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        backgroundColor: '#e9ecef',
                        color: '#495057',
                        fontSize: '11px'
                      }}
                    >
                      <i className="fas fa-search" />
                    </span>
                    <UncontrolledTooltip
                      target={`comentario-${index}`}
                      placement="top"
                      delay={0}
                      className="custom-tooltip"
                    >
                      {dato.ausencia.comentario}
                    </UncontrolledTooltip>
                  </>
                )}
              </td>
              <td style={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}>{getTipoComputoLabel(dato.ausencia)}</td>

              <td style={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}>{dato.solicitud.fechaSolicitud}</td>
              <td style={{ textAlign: 'center' }}>
                <UncontrolledDropdown>
                  <DropdownToggle
                      className="btn-icon-only"
                      href=""
                      role="button"
                      size="sm"
                      color=""
                      onClick={(e) => e.preventDefault()}
                  >
                    <i className="fas fa-ellipsis-v"/>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-arrow" right>

                    <DropdownItem className="text-success" onClick={() => handleTramitar(dato.solicitud.id, "APROBADA") }>Aprobar</DropdownItem>


                    <DropdownItem className="text-danger" onClick={() => handleTramitar(dato.solicitud.id, "RECHAZADA")}>
                      Rechazar
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>


              </td>
            </tr>
        ))}
        </tbody>

      </Table>
      </div>
      <br/>

    </>
  )
}

export default ListaAprobarVacaciones
